// libs
import { styled } from '@nykaa/ui-components';

//components
import BaseOverlaySheet from 'shared/components/OverlaySheet';
// import BaseButton from '@nykaa/ui-components/Button';
import BaseButton from 'shared/components/Button';
export const OverlaySheet = styled(BaseOverlaySheet)`
  width: 460px;
  height: 100%;
  top: initial;
  left: initial;

  ${({ theme }) =>
    `padding: ${theme.spacing.spacing100};
    background-color: ${theme.colors.overlayBg};
  `};
`;

export const Container = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const Title = styled.div`
  ${({ theme }) => theme.typography.titleLarge};
`;

export const Subtitle = styled.div`
  width: 70%;
  ${({ theme }) => theme.typography.bodyLarge};

  ${({ theme }) =>
    `margin-top: ${theme.spacing.spacing80};
    margin-bottom: ${theme.spacing.spacing60};
  `};
`;

export const Button = styled(BaseButton) <{ isApplyButton?: boolean }>`
  width: 80%;
  ${({ theme }) => theme.typography.buttonLarge};
  
  ${({ theme }) =>
    `margin-top: ${theme.spacing.spacing60};
    // border-radius: ${theme.spacing.spacing10};
    border: 1px solid ${theme.colors.textOutline};
  `};
  background: ${({ isApplyButton, theme }) => isApplyButton ? theme.colors.primary : 'transparent'};
  color: ${({ isApplyButton, theme }) => isApplyButton ? theme.colors.surface : theme.colors.textPrimary};
  &:hover{ 
    background: ${({ isApplyButton, theme }) => isApplyButton ? theme.colors.primary10 : 'transparent'} !important;
  }
`;

export const CrossIconButton = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
`;
